// src/App.js
import { Routes, Route, Navigate } from "react-router-dom";
import { ToastProvider } from "./components/shared/toast/ToastProvider";
import { AuthProvider } from "./hooks/useAuth";

 import Jazo from "./pages/Jazo";
// import LandingPage from "./pages/LandingPage";
// import AuthPage from "./pages/AuthPage";
// import ActivationPage from "./pages/ActivationPage";
// import ActivationSuccessPage from "./pages/ActivationSuccessPage";
// import PrivacyPage from "./pages/PrivacyPage";
// import ImpressumPage from "./pages/ImpressumPage";
// import ForgotPasswordPage from "./pages/ForgotPasswordPage";
// import ResetPasswordPage from "./pages/ResetPasswordPage";

// import FamilyProfilePage from "./pages/familly/FamilyProfilePage";
// import CandidatesFamilyPage from "./pages/familly/CandidatesFamilyPage";
// import FamilyChatPage from "./pages/familly/FamilyChatPage";
// import CandidateChatPage from "./pages/candidate/CandidateChatPage";
// import CandidateProfilePage from "./pages/candidate/CandidateProfile";

// import FamilyDashboard from "./pages/familly/FamilyDashboard";
// import CandidateDashboard from "./pages/candidate/CandidateDashboard";

// import PrivateRoute from "./components/PrivateRoute";
// import RoleRedirector from "./components/auth/RoleRedirector";

// import PublicLayout from "./pages/PublicLayout";

// // INFO pages
// import WarumAuPair from "./pages/info/au-pairs/WarumAuPair";
// import AuPairDeutschland from "./pages/info/au-pairs/AuPairDeutschland";
// import Handytarife from "./pages/info/au-pairs/Handytarife";
// import OnlineDeutschkurse from "./pages/info/au-pairs/OnlineDeutschkurse";
// import Bankkonten from "./pages/info/au-pairs/Bankkonten";
// import FreiwilligesSozialesJahr from "./pages/info/au-pairs/FreiwilligesSozialesJahr";
// import FlugeNachDeutschland from "./pages/info/au-pairs/FlugeNachDeutschland";
// import BewerbungAlsAuPairInDeutschland from "./pages/info/au-pairs/BewerbungAlsAuPairInDeutschland";

// import Allgemeines from "./pages/info/gasteltern/Allgemeines";
// import Dienstleistungen from "./pages/info/gasteltern/Dienstleistungen";
// import Konsten from "./pages/info/gasteltern/Konsten";
// import Beratungsangebot from "./pages/info/gasteltern/Beratungsangebot";
// import Informationsmappe from "./pages/info/gasteltern/Informationsmappe";
// import AuPairKrankenversicherung from "./pages/info/gasteltern/AuPairKrankenversicherung";

// import UeberUns from "./pages/info/UeberUns";
// import Kontakt from "./pages/info/Kontakt";

export default function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <Routes>
          <Route index element={<Jazo />} />
           {/* Public with shared Header/Footer */}
           {/*
          <Route element={<PublicLayout />}>
            
            <Route path="datenschutz" element={<PrivacyPage />} />
            <Route path="impressum" element={<ImpressumPage />} />

            //  Für Au Pairs 
            <Route path="fuer-au-pairs/warum-au-pair" element={<WarumAuPair />} />
            <Route path="fuer-au-pairs/au-pair-in-deutschland" element={<AuPairDeutschland />} />
            <Route path="fuer-au-pairs/handytarife" element={<Handytarife />} />
            <Route path="fuer-au-pairs/online-deutschkurse" element={<OnlineDeutschkurse />} />
            <Route path="fuer-au-pairs/bankkonten" element={<Bankkonten />} />
            <Route path="fuer-au-pairs/freiwilliges-soziales-jahr" element={<FreiwilligesSozialesJahr />} />
            <Route path="fuer-au-pairs/fluege-nach-deutschland" element={<FlugeNachDeutschland />} />
            <Route path="bewerbung-als-au-pair-in-deutschland" element={<BewerbungAlsAuPairInDeutschland />} />

            // Für Gasteltern 
            <Route path="fuer-gasteltern/allgemeines" element={<Allgemeines />} />
            <Route path="fuer-gasteltern/dienstleistungen" element={<Dienstleistungen />} />
            <Route path="fuer-gasteltern/konsten" element={<Konsten />} />
            <Route path="fuer-gasteltern/beratungsangebot" element={<Beratungsangebot />} />
            <Route path="fuer-gasteltern/informationsmappe" element={<Informationsmappe />} />
            <Route path="au-pair-krankenversicherung" element={<AuPairKrankenversicherung />} />
            //  Static 
            <Route path="ueber-uns" element={<UeberUns />} />
            <Route path="kontakt" element={<Kontakt />} />
          </Route>

          // Public no-layout pages 
          <Route path="/auth" element={<AuthPage />} />
          <Route path="/activate/:token" element={<ActivationPage />} />
          <Route path="/activation-success" element={<ActivationSuccessPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password/:token" element={<ResetPasswordPage />} />

          // Protected 
          <Route element={<PrivateRoute />}>
            <Route path="/dashboard" element={<RoleRedirector />} />

            <Route path="/candidate" element={<CandidateDashboard />}>
              <Route index element={<Navigate to="profile" replace />} />
              <Route path="profile" element={<CandidateProfilePage />} />
              <Route path="messages" element={<CandidateChatPage />} />
            </Route>

            <Route path="/family" element={<FamilyDashboard />}>
              <Route index element={<Navigate to="candidates" replace />} />
              <Route path="profile" element={<FamilyProfilePage />} />
              <Route path="candidates" element={<CandidatesFamilyPage />} />
              <Route path="messages" element={<FamilyChatPage />} />
              <Route path="messages/:conversationId" element={<FamilyChatPage />} />
            </Route>
          </Route> */}

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </ToastProvider>
    </AuthProvider>
  );
}
